import script from "./ModalFeedback.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalFeedback.vue?vue&type=script&setup=true&lang=js"

import "./ModalFeedback.vue?vue&type=style&index=0&id=76fb7a05&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76fb7a05"]])

export default __exports__